export const QUERY_KEY = {
  filter: 'filter',
  rowsPerPage: 'rowsPerPage',
  page: 'page',
  showPopUp: 'showPopUp',
};
